/** @jsxImportSource @emotion/react */
import { useSetAtom } from 'jotai';
import { useCallingAddon } from '../hooks/use-calling-addon';
import { useEffect } from 'react';
import { waVoiceTrialAutoOpenAtom, waVoiceUpgradeModalOpen } from '../states';
import { WA_VOICE_TRIAL_DISMISSED } from '../constants';
import { useSelectedOrganization } from '../../../../shared/hooks/use-organizations';

export const useWaVoiceTrialModal = () => {
  const setUpgradeModal = useSetAtom(waVoiceUpgradeModalOpen);
  const setIsAutoOpen = useSetAtom(waVoiceTrialAutoOpenAtom);
  const { canShowCallingFreeTrial, isSubscriptionLoading } = useCallingAddon();
  const currentOrg = useSelectedOrganization();

  useEffect(() => {
    if (isSubscriptionLoading) return;

    const dismissedKey = currentOrg ? `${WA_VOICE_TRIAL_DISMISSED}_${currentOrg.orgId}` : WA_VOICE_TRIAL_DISMISSED;
    const isDismissed = localStorage.getItem(dismissedKey);

    if (canShowCallingFreeTrial && !isDismissed) {
      const timer = setTimeout(() => {
        setIsAutoOpen(true);
        setUpgradeModal(true);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [isSubscriptionLoading, canShowCallingFreeTrial, setUpgradeModal, setIsAutoOpen, currentOrg]);
};
